import { useEffect, useState } from "preact/hooks";
import fetchSwatchDetails from "./fetchSwatchDetails";

/**
 * @param {?string} gid product gid, or null to fetch nothing
 * @returns {[?Object, boolean]} [details, loading]
 */
export default function useSwatchDetails(gid) {
  const [resolved, setResolved] = useState({ gid: null, data: null });

  useEffect(() => {
    if (!gid) return;

    let current = true;

    fetchSwatchDetails(gid).then((data) => {
      // The gid changes as chips are clicked; a slower earlier response must
      // not land on top of a newer one.
      if (current) setResolved({ gid, data });
    });

    return () => {
      current = false;
    };
  }, [gid]);

  const settled = !!gid && resolved.gid === gid;

  return [settled ? resolved.data : null, !!gid && !settled];
}
